import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDataMyIngredientsRequestLocal,
  setDataMyIngredientsRequestLocal,
} from "./../store/actions";
import type { TIngredient } from "./../store/types";
import { appLang } from "core/utils/helper";

export const useMyIngredientRequested = () => {
  const dispatch = useDispatch()
  const user = useSelector((state: any) => state.Auth.userInfo);
  const myIngredientsRequested = useSelector(
    (state: any) => state.Ingredients.myIngredientsRequested
  );
  const {localData: ingredients = []} = myIngredientsRequested || {};

  useEffect(() => {
    if (user?.id) {
      dispatch(getDataMyIngredientsRequestLocal({
        user_id: user?.id,
        lang: appLang(),
      }))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, appLang])

  const addToMyIngredientsRequest = useCallback((items: TIngredient[]) => {
    if (items.length) {
      // dispatch(updateMyIngredients({
      //   action: UpdateMyIngredientActionEnum.ADD,
      //   ids: items.map((e: any) => e.id)
      // }))
      dispatch(setDataMyIngredientsRequestLocal({
        user_id: user?.id,
        lang: appLang(),
        data: items
      }))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setDataMyIngredientsRequestLocal, appLang, user?.id])

  return {
    ingredients: (ingredients || []) as TIngredient[],
    addToMyIngredientsRequest,
  }
}
